module.exports = __webpack_public_path__ + "img/2.e95ee223.jpg";